import { createServer, Model } from 'miragejs';
import { endpoints } from 'mocks/api';
import { DOMAIN, IS_DEV, MOCK_TIMING, AUTH0_DOMAIN, API_BASE_URL } from 'config';
import { seedInitialViews } from 'mocks/api/handlers/views';

export const mockServer = (environment = 'development') => {
  const server = createServer({
    environment,
    timing: MOCK_TIMING ? parseInt(MOCK_TIMING) : 400,

    models: {
      otpAttempt: Model,
      view: Model,
      apiSupplier: Model,
      apiUser: Model,
    },

    seeds(mirageServer) {
      seedInitialViews(mirageServer);
    },

    routes() {
      this.logging = IS_DEV;
      const NativeXMLHttpRequest = window.XMLHttpRequest;
      // @ts-expect-error: patching a bug in pretenderjs
      window.XMLHttpRequest = function XMLHttpRequest() {
        const request = new NativeXMLHttpRequest();
        // @ts-expect-error: patching a bug in pretenderjs
        delete request.onloadend;
        return request;
      };

      // Configure routes for DOMAIN (legacy API)
      this.urlPrefix = DOMAIN;
      endpoints(this);

      // General passthrough for unmatched routes to DOMAIN
      this.passthrough();

      // Passthrough new Delogue.Api
      if (API_BASE_URL) {
        this.passthrough(`${API_BASE_URL}/**`);
      }

      // Passthrough Auth0 requests
      if (AUTH0_DOMAIN) {
        this.passthrough(`https://${AUTH0_DOMAIN}/**`);
      }

      // Passthrough external services
      this.passthrough('https://s3-eu-west-1.amazonaws.com/**');
      this.passthrough('https://official-joke-api.appspot.com/**');
      this.passthrough('https://catfact.ninja/**');
      this.passthrough('https://sentry.io/**');
      this.passthrough('https://cdn.segment.com/**');
      this.passthrough('https://api.segment.io/**');
      this.passthrough('https://exceptions.hubspot.com/**');
      this.passthrough('https://api.hubspot.com/**');
    },
  });

  return server;
};
